import React, { useState, useEffect, useRef } from "react";
import { showToast } from "../Shared/ToastMessage";
import axios from "axios";
import { localserver, ROUTE_BASE_URL } from "../../api/common";
import { useHistory } from "react-router-dom";
import Cookies from "js-cookie";

export default function OtpVerify({ adminEmail, mailOtp }) {
  const history = useHistory();
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [otpExpiryTime, setOtpExpiryTime] = useState(300); // 5 minutes
  const [resendTime, setResendTime] = useState(60); // 1 minute
  const [canResend, setCanResend] = useState(false);
  const [verifyOtpStatus, setVerifyOtpStatus] = useState(false);
  const [isResending, setIsResending] = useState(false);

  // Use refs to store interval IDs
  const expiryIntervalRef = useRef(null);
  const resendIntervalRef = useRef(null);

  // Utility Methods
  const formatTime = (timeInSeconds) => {
    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = timeInSeconds % 60;
    return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  };

  const calculateProgress = (current, total) => {
    return (current / total) * 100;
  };

  const resetResendTimer = () => {
    setResendTime(60);
    setCanResend(false);
    startResendTimer();
  };

  const startExpiryTimer = () => {
    if (expiryIntervalRef.current) {
      clearInterval(expiryIntervalRef.current);
    }

    expiryIntervalRef.current = setInterval(() => {
      setOtpExpiryTime((prevTime) => {
        console.log("OTP Expiry Time:", prevTime);
        if (prevTime <= 1) {
          clearInterval(expiryIntervalRef.current);
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);
  };

  const startResendTimer = () => {
    if (resendIntervalRef.current) {
      clearInterval(resendIntervalRef.current);
    }

    resendIntervalRef.current = setInterval(() => {
      setResendTime((prevTime) => {
        console.log("Resend Time:", prevTime);
        if (prevTime <= 1) {
          clearInterval(resendIntervalRef.current);
          setCanResend(true);
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);
  };

  // Event Handlers
  const handleOtpChange = (e, index) => {
    const { value } = e.target;
    if (value.match(/^\d?$/)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      if (value && index < 5) {
        document.getElementById(`otp-${index + 1}`).focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      document.getElementById(`otp-${index - 1}`).focus();
    }
  };

  // API Methods
  const resendOtp = async () => {
    setIsResending(true);
    try {
      const { data } = await axios.post(
        `${localserver}/send_otp_mail`,
        { email_id: adminEmail },
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      console.log(data, "response.data");

      if (data.success) {
        // Reset timers on successful resend
        setOtpExpiryTime(300);
        startExpiryTimer();
        resetResendTimer();
        setOtp(["", "", "", "", "", ""]);
      }

      showToast(data.message, data.success ? "success" : "error");
    } catch {
      showToast("Please try again", "error");
    } finally {
      setIsResending(false);
    }
  };

  const verifyOtp = async () => {
    if (otpExpiryTime <= 0) {
      showToast("OTP has expired. Please request a new one.", "warning");
      return;
    }

    const enteredOtp = otp.join("");
    if (enteredOtp.length !== 6) {
      showToast("Please enter complete 6-digit OTP", "warning");
      return;
    }

    setVerifyOtpStatus(true);
    try {
      const { data } = await axios.post(
        `${localserver}/verify_mail_otp`,
        { email_id: adminEmail, otp_code: enteredOtp },
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      console.log(data, "response.data");

      if (data.success) {
        showToast(data.message, "success");
        Cookies.set("userId", data.user.id, { expires: 1 });
        localStorage.setItem("access_token", data.token);
        localStorage.setItem("loginUserId", data.user.id);
        localStorage.setItem(
          "loginUserName",
          `${data.user.first_name} ${data.user.last_name}`
        );
        setOtp(["", "", "", "", "", ""]);

        // Clear timers before navigation
        if (expiryIntervalRef.current) clearInterval(expiryIntervalRef.current);
        if (resendIntervalRef.current) clearInterval(resendIntervalRef.current);

        history.replace(`${ROUTE_BASE_URL}`);
      } else {
        showToast(data.message, "error");
      }
    } catch {
      showToast("Please try again", "error");
    } finally {
      setVerifyOtpStatus(false);
    }
  };

  // Initialize timers on component mount
  useEffect(() => {
    console.log("Component mounted, starting timers...");
    startExpiryTimer();
    startResendTimer();

    return () => {
      console.log("Component unmounting, clearing timers...");
      if (expiryIntervalRef.current) {
        clearInterval(expiryIntervalRef.current);
      }
      if (resendIntervalRef.current) {
        clearInterval(resendIntervalRef.current);
      }
    };
  }, []);

  // JSX Methods for UI Components
  const renderHeader = () => {
    return (
      <div style={{ textAlign: "center", marginBottom: "40px" }}>
        <h1
          style={{
            fontSize: "28px",
            fontWeight: "bold",
            color: "#1a1a1a",
            marginBottom: "12px",
            margin: "0 0 12px 0",
          }}
        >
          Verify Your Email
          {/* Your OTP: {mailOtp} */}
        </h1>
        <p
          style={{
            color: "#666666",
            fontSize: "14px",
            lineHeight: "1.5",
            margin: "0",
          }}
        >
          We've sent a 6-digit verification code to your email address
          OTP 
        </p>
      </div>
    );
  };

  const renderClockIcon = () => {
    return (
      <div
        style={{
          width: "16px",
          height: "16px",
          borderRadius: "50%",
          border: "2px solid #666666",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginRight: "8px",
          flexShrink: 0,
        }}
      >
        <div
          style={{
            width: "4px",
            height: "4px",
            backgroundColor: "#666666",
            borderRadius: "50%",
          }}
        ></div>
      </div>
    );
  };

  const renderTimerSection = () => {
    console.log("Rendering timer section, otpExpiryTime:", otpExpiryTime);

    return (
      <div style={{ marginBottom: "32px" }}>
        {/* Timer Label */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "12px",
          }}
        >
          {renderClockIcon()}
          <span
            style={{
              fontSize: "14px",
              color: "#666666",
              marginRight: "8px",
            }}
          >
            Code expires in:
          </span>
          <span
            style={{
              fontSize: "14px",
              fontWeight: "600",
              color: "#4285f4",
            }}
          >
            {formatTime(otpExpiryTime)}
          </span>
        </div>

        {/* Progress Bar */}
        <div
          style={{
            width: "100%",
            height: "8px",
            backgroundColor: "#e5e5e5",
            borderRadius: "4px",
            overflow: "hidden",
          }}
        >
          <div
            style={{
              height: "100%",
              backgroundColor: otpExpiryTime <= 60 ? "#ff4444" : "#1a1a1a",
              width: `${calculateProgress(otpExpiryTime, 300)}%`,
              transition: "width 0.5s ease-in-out",
              borderRadius: "4px",
            }}
          />
        </div>
      </div>
    );
  };

  const renderOtpInput = (digit, index) => {
    return (
      <input
        key={index}
        id={`otp-${index}`}
        type="text"
        style={{
          width: "48px",
          height: "48px",
          textAlign: "center",
          fontSize: "18px",
          fontWeight: "500",
          border: "2px solid #d1d5db",
          borderRadius: "8px",
          outline: "none",
          backgroundColor:
            otpExpiryTime <= 0 || verifyOtpStatus ? "#f3f4f6" : "#ffffff",
        }}
        maxLength={1}
        value={digit}
        onChange={(e) => handleOtpChange(e, index)}
        onKeyDown={(e) => handleKeyDown(e, index)}
        onFocus={(e) => {
          e.target.style.borderColor = "#4285f4";
        }}
        onBlur={(e) => {
          e.target.style.borderColor = "#d1d5db";
        }}
        disabled={otpExpiryTime <= 0 || verifyOtpStatus}
        autoComplete="off"
      />
    );
  };

  const renderOtpInputGroup = () => {
    const remainingDigits = otp.filter((digit) => digit === "").length;

    return (
      <div style={{ marginBottom: "24px" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "12px",
            marginBottom: "16px",
          }}
        >
          {otp.map((digit, index) => renderOtpInput(digit, index))}
        </div>
        {/* <div style={{ textAlign: "center" }}>
          <span
            style={{
              fontSize: "14px",
              color: "#9ca3af",
            }}
          >
            Enter {remainingDigits} more digits
          </span>
        </div> */}
      </div>
    );
  };

  const renderVerifyButton = () => {
    const isOtpComplete = otp.every((digit) => digit !== "");
    const isExpired = otpExpiryTime <= 0;
    const isDisabled = !isOtpComplete || isExpired || verifyOtpStatus;

    return (
      <button
        onClick={verifyOtp}
        style={{
          width: "100%",
          padding: "12px 16px",
          borderRadius: "8px",
          fontWeight: "500",
          fontSize: "16px",
          border: "none",
          cursor: isDisabled ? "not-allowed" : "pointer",
          backgroundColor: isDisabled ? "#e5e7eb" : "#4285f4",
          color: isDisabled ? "#9ca3af" : "#ffffff",
          transition: "all 0.2s ease-in-out",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        disabled={isDisabled}
        onMouseOver={(e) => {
          if (!isDisabled) {
            e.target.style.backgroundColor = "#3367d6";
          }
        }}
        onMouseOut={(e) => {
          if (!isDisabled) {
            e.target.style.backgroundColor = "#4285f4";
          }
        }}
      >
        {verifyOtpStatus ? (
          <>
            <span
              style={{
                width: "16px",
                height: "16px",
                border: "2px solid #ffffff",
                borderTop: "2px solid transparent",
                borderRadius: "50%",
                animation: "spin 1s linear infinite",
                marginRight: "8px",
              }}
            ></span>
            Processing...
          </>
        ) : (
          "Verify OTP"
        )}
      </button>
    );
  };

  const renderBottomSection = () => {
    return (
      <div style={{ textAlign: "center", marginTop: "32px" }}>
        <p
          style={{
            fontSize: "14px",
            color: "#666666",
            marginBottom: "16px",
            margin: "0 0 16px 0",
          }}
        >
          Didn't receive the code? Check your spam folder
        </p>

        {canResend ? (
          <button
            onClick={resendOtp}
            style={{
              fontSize: "14px",
              color: "#4285f4",
              fontWeight: "500",
              background: "none",
              border: "none",
              cursor: "pointer",
              textDecoration: "none",
            }}
            disabled={isResending}
            onMouseOver={(e) => {
              if (!isResending) {
                e.target.style.color = "#3367d6";
              }
            }}
            onMouseOut={(e) => {
              if (!isResending) {
                e.target.style.color = "#4285f4";
              }
            }}
          >
            {isResending ? "Sending..." : "Resend Code"}
          </button>
        ) : (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "14px",
              color: "#9ca3af",
            }}
          >
            {renderClockIcon()}
            <span>Resend available in {resendTime}s</span>
          </div>
        )}
      </div>
    );
  };

  const renderMainContent = () => {
    return (
      <div
        style={{
          minHeight: "100vh",
          backgroundColor: "#f9fafb",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "16px",
        }}
      >
        <div
          style={{
            backgroundColor: "#ffffff",
            borderRadius: "12px",
            boxShadow: "0 10px 25px rgba(0, 0, 0, 0.1)",
            padding: "48px",
            width: "100%",
            maxWidth: "480px",
          }}
        >
          {renderHeader()}
          {renderTimerSection()}
          {renderOtpInputGroup()}
          {renderVerifyButton()}
          {renderBottomSection()}
        </div>

        {/* Add CSS animation for spinner */}
        <style>
          {`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}
        </style>
      </div>
    );
  };

  // Main Render Method
  return <>{renderMainContent()}</>;
}
